// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle[data-v-0a10c534],.v-card>h2[data-v-0a10c534]{color:#1e88e5;font-weight:700}a[data-v-0a10c534]{text-decoration:none}.right[data-v-0a10c534]{float:right}.v-card p[data-v-0a10c534]{text-align:center}.v-card .v-image[data-v-0a10c534]{-webkit-transform:translate(-50%);transform:translate(-50%);left:50%;opacity:.6}.icon-image[data-v-0a10c534]{opacity:.5;float:right}.white[data-v-0a10c534]{-webkit-filter:invert(1);filter:invert(1);mix-blend-mode:lighten}", ""]);
// Exports
module.exports = exports;
